module.exports = __webpack_public_path__ + "static/media/tutorial-01.c2b3d5c6.jpg";